let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6SwG8")).then(() => parcelRequire('dK6BZ'));